<script>
export default {
  name: "ImageComponent",
  props: {
    imageSrc: {
      type: String,
      required: true
    }
  }
}
</script>

<template>
  <div class="image">
    <img :src="imageSrc" />
  </div>
</template>

<style scoped>

.image {
  margin-bottom: 5px;
}

@media (max-width: 768px) {

  .image {
    margin-bottom: 10px;
  }

}

</style>
